export const formatCurrency = (n) => {
    const val = Number(n) || 0;
    return val.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' TL';
};
